export const MAIN_SET_MESSAGE = 'MAIN_SET_MESSAGE'
export const MAIN_SET_FETCHING = 'MAIN_SET_FETCHING'

export const CATEGORIES_SET_DATA = 'CATEGORIES_SET_DATA'
export const PRODUCTS_SET_DATA = 'PRODUCTS_SET_DATA'

export const CONTRACTS_SET = 'CONTRACTS_SET'
export const CONTRACT_ACTIVE = 'CONTRACT_ACTIVE'
export const CONTRACTS_TOGGLE_LINE = 'CONTRACTS_TOGGLE_LINE'
export const MENU_REMOVE_ARTICLE = 'MENU_REMOVE_ARTICLE'

export const SET_INTERMEDIATE_GROUP = 'SET_INTERMEDIATE_GROUP'
export const SET_ARTICLE_QUANTITY = 'SET_ARTICLE_QUANTITY'
export const SET_ARTICLE_INTERVAL = 'SET_ARTICLE_INTERVAL'

export const MENU_ADD_TO_CART = 'MENU_ADD_TO_CART'

export const SINGLE_ADD_TO_CART = 'SINGLE_ADD_TO_CART'
export const SINGLE_REMOVE_FROM_CART = 'SINGLE_REMOVE_FROM_CART'
export const SINGLE_ARTICLE_QUANTITY = 'SINGLE_ARTICLE_QUANTITY'
export const SINGLE_EMPTY_CART = 'SINGLE_EMPTY_CART'

//export const APPEND_LOCAL_CART = 'APPEND_LOCAL_CART'
export const SINGLE_ARTICLE_PRICE = 'SINGLE_ARTICLE_PRICE'
export const SINGLE_REPLACE_CART = 'SINGLE_REPLACE_CART'



// WEBPACK FOOTER //
// ./src/store/types.js